const CATEGORY_COLOR_MAP = {
  "bg-cyan-400": "#22d3ee",
  "bg-yellow-400": "#facc15",
  "bg-green-400": "#4ade80",
  "bg-violet-400": "#a78bfa",
  "bg-fuchsia-400": "#e879f9",
  "bg-teal-400": "#2dd4bf",
  "bg-gray-400": "#9ca3af",
  "bg-pink-400": "#f472b6",
  "bg-lime-400": "#84cc16",
  "bg-sky-400": "#38bdf8",
  "bg-orange-400": "#fb923c",
  "bg-rose-400": "#fb7185",
  "bg-stone-400": "#a8a29e",
  "bg-yellow-600": "#ca8a04",
};

const getColorFromCategoryClassName = (className) => {
  for (const [colorClass, hexColor] of Object.entries(CATEGORY_COLOR_MAP)) {
    if (className.includes(colorClass)) {
      return hexColor;
    }
  }
  return "#3b82f6"; // blue-500 default
};

const createCategoryCustomIcon = (L, categoryIcons, categoryId) => {
  const category = categoryIcons[categoryId];

  if (!category) {
    // Default Leaflet marker icon (same config as before)
    return L.icon({
      iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
      iconRetinaUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
      shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
  }

  const backgroundColor = getColorFromCategoryClassName(category.className);

  const iconHtml = `
    <div style="
      width: 40px;
      height: 40px;
      background-color: ${backgroundColor};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      border: 2px solid white;
    ">
      <svg 
        width="24" 
        height="24" 
        viewBox="${category.viewBox || "0 0 512 512"}" 
        fill="white"
        style="display: block;"
      >
        <path d="${category.svgIcon}" />
      </svg>
    </div>
  `;

  return L.divIcon({
    html: iconHtml,
    className: "custom-marker-icon",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });
};
module.exports = {
  getColorFromCategoryClassName,
  createCategoryCustomIcon,
};